<script lang="ts" setup>
import { computed } from 'vue'

import { StatId } from '@collector/sportsapi-client-legacy'
import { useParticipantStatsMaps } from '@desktop/views/Relation/composables'
import { useBaseballParticipants } from '@desktop/views/Relation/Sports/Baseball/composables'

interface Props {
  label: string
  statId: StatId
}

const props = defineProps<Props>()

const { battingParticipant } = useBaseballParticipants()
const { homeParticipantStatsMap, awayParticipantStatsMap } =
  useParticipantStatsMaps()

const value = computed(() => {
  const participant = battingParticipant.value
  if (!participant) {
    return '-'
  }

  const statsMap =
    participant.counter === 1
      ? homeParticipantStatsMap.value
      : awayParticipantStatsMap.value

  return statsMap[props.statId]?.value ?? '-'
})
</script>

<template>
  <span class="flex items-center gap-x-1 font-bold">
    <span class="text-sm">{{ label }}</span>
    <span class="text-error-5">{{ value }}</span>
  </span>
</template>
